import { ComingSoonTag, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Tooltip,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import { BulkInputFilterItem } from './components/bulk-input-filter-item';
import * as SX from './sx';
import type { BulkInputFilterProps as Props } from './types';

export const BulkInputFilter = memo(({ className, ...filter }: Props) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      className={classnames('BulkInputFilter', className)}
      sx={SX.root}
    >
      <Divider>
        <Box display="flex" alignItems="center">
          <Typography variant="body5" color="grey.500">
            Add in Bulk Search
          </Typography>
        </Box>
      </Divider>

      <Card variant="filled" color="default">
        <CardHeader
          title={
            <Box display="flex" alignItems="center" width="100%" gap={1}>
              <Typography variant="body3" color="grey.600" fontWeight={500}>
                {filter.name}
              </Typography>
              {filter.metadata?.info && (
                <Tooltip
                  title={filter.metadata?.info}
                  arrow
                  placement="right"
                  maxWidth="unset"
                  enterDelay={200}
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Icon name="info" size={16} color="grey.400" />
                  </Box>
                </Tooltip>
              )}
            </Box>
          }
        />
        <CardContent>
          <Box display="flex" flexDirection="column" gap={1}>
            {filter.items?.map((item) => {
              return <BulkInputFilterItem key={item.field} item={item} />;
            })}
          </Box>
        </CardContent>
      </Card>

      {filter.comingSoon && <ComingSoonTag />}
    </Box>
  );
});

BulkInputFilter.displayName = 'BulkInputFilter';
